/**
 * A function that will completely reset store modules.
 * It's mostly used in the destroy method on the page components.
 *
 * @param store
 * @returns {function(...[*]): void}
 */
export var resetStoreModules = function resetStoreModules(store) {
  return function () {
    var modules = {};
    for (var _len = arguments.length, moduleNames = new Array(_len), _key = 0; _key < _len; _key++) {
      moduleNames[_key] = arguments[_key];
    }
    moduleNames.forEach(function (moduleName) {
      modules[moduleName] = {
        self: true,
        nested: true
      };
    });
    store.reset({
      self: false,
      nested: false,
      modules: modules
    });
  };
};